function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Group 11"
}, React.createElement("g", {
  "data-name": "Group 10",
  stroke: "#3f5063",
  strokeMiterlimit: 10,
  strokeWidth: 2
}, React.createElement("path", {
  "data-name": "Fill 4",
  d: "M43.918 2.308l-6.787 34.07a2.515 2.515 0 0 1-3.56 1.229L17.905 25.652l-5.7-2.741L2.627 19.7s-1.472-.522-1.614-1.656S2.674 16.3 2.674 16.3L40.786 1.41s3.132-1.37 3.132.9",
  fill: "none"
}), React.createElement("path", {
  "data-name": "Fill 6",
  d: "M16.447 35.925s-.457-.043-1.027-1.839-3.465-11.25-3.465-11.25L34.974 8.282s1.329-.8 1.281 0c0 0 .237.142-.475.8S17.698 25.293 17.698 25.293",
  fill: "#fff"
}), React.createElement("path", {
  "data-name": "Fill 8",
  d: "M23.914 30.236l-6.2 5.624a1.089 1.089 0 0 1-1.009.136l1.186-10.446",
  fill: "none"
})));

var SvgTelegram = function SvgTelegram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 44.918,
    height: 38.929,
    color: "#fff",
    viewBox: "0 0 44.918 38.929",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTelegram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telegram.e108e59d.svg";
export { ForwardRef as ReactComponent };